
const customViewsTypes = {
  VIEW_META_SET: 'VIEW_META_SET',
  VIEW_ITEMS_SET: 'VIEW_ITEMS_SET',
  RESOURCE_VIEWS_SET: 'RESOURCE_VIEWS_SET',
};
export default customViewsTypes;